import { clsx } from 'clsx'
import { useState } from 'react'

import { Button } from '~/components/Button.tsx'
import { useOnboardingGoals } from '~/features/onboarding/data.ts'
import { useWorkspace } from '~/features/workspaces/data.ts'

import styles from './WhatsNext.module.scss'
import { SidebarAddon } from '../../components/SidebarAddon.tsx'
import { Text } from '../../components/Text.tsx'
import { TodoList, TodoListItem } from '../../components/TodoList.tsx'

interface Props {
  handleDoneOnboarding: () => void
}

function WhatsNext(props: Props) {
  const { handleDoneOnboarding } = props
  const { data: workspaceData } = useWorkspace()
  const { data: onboardingGoalsData } = useOnboardingGoals()
  const [isDisappearing, setIsDisappearing] = useState(false)

  if (!onboardingGoalsData || workspaceData?.login_data.isImpersonated) return null

  const onboardingHasBeenCompletedOverAWeekAgo = Boolean(
    onboardingGoalsData.goals.has_assembly_from_integration !== null &&
      new Date(onboardingGoalsData.goals.has_assembly_from_integration!) <
        new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000),
  )

  if (onboardingHasBeenCompletedOverAWeekAgo) return null

  const handleClick = () => {
    setIsDisappearing(true)
    handleDoneOnboarding()
  }

  return (
    <SidebarAddon
      title="What’s next?"
      className={clsx({
        [styles.disappear]: isDisappearing,
      })}
    >
      <TodoList>
        <TodoListItem
          title="Create a Template"
          variant={onboardingGoalsData.goals.first_template ? 'completed' : 'current'}
        />
        <TodoListItem
          title="Test & Iterate"
          variant={
            // eslint-disable-next-line no-nested-ternary
            onboardingGoalsData.goals.has_assembly_from_template_editor ||
            onboardingGoalsData.goals.has_assembly_from_integration
              ? 'completed'
              : onboardingGoalsData.goals.first_template
                ? 'current'
                : undefined
          }
          description={
            <Text>
              Drag your files anywhere on the Template page or use the Testing area there.
            </Text>
          }
        />
        <TodoListItem
          title="Integrate"
          variant={
            // eslint-disable-next-line no-nested-ternary
            onboardingGoalsData.goals.has_assembly_from_integration
              ? 'completed'
              : onboardingGoalsData.goals.has_assembly_from_template_editor
                ? 'current'
                : undefined
          }
          description={
            <Text>
              Choose an SDK in the Integration section on the Template page. Then, execute your
              first Assembly from your app to complete the setup.
            </Text>
          }
        />
      </TodoList>
      {onboardingGoalsData.goals.has_assembly_from_integration !== null && (
        <>
          <Text>You've successfully integrated with Transloadit. Congrats!</Text>
          <Button onClick={handleClick} variant="link">
            Hide Checklist
          </Button>
        </>
      )}
    </SidebarAddon>
  )
}

export default WhatsNext
